import { ArrowRight, ExternalLink, History, Smartphone } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router';
import { asetquLandEnabled } from '@/lib/features';

const TopInfoBar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const pathname = location.pathname;

  // Determine which section we're in and set appropriate text and link
  const getInfoBannerData = () => {
    if (pathname.startsWith('/propribid') || pathname === '/my-auctions') {
      return {
        title: 'My Propribid',
        subtitle: 'List of property auctions you have participated in',
        link: '/my-auctions',
      };
    }

    if (pathname.startsWith('/proprimarket') || pathname === '/profile/proprimarket-history') {
      return {
        title: 'My Proprimarket',
        subtitle: 'List of properties you have purchased',
        link: '/profile/proprimarket-history',
      };
    }

    if (pathname.startsWith('/proprivoucher') || pathname === '/my-vouchers') {
      return {
        title: 'My Proprivoucher',
        subtitle: 'List of vouchers you have collected',
        link: '/my-vouchers',
      };
    }

    if (pathname.startsWith('/academy') || pathname === '/my-aset-academy') {
      return {
        title: 'My Aset Academy',
        subtitle: 'List of courses you have enrolled in',
        link: '/my-aset-academy',
      };
    }

    if (asetquLandEnabled && (pathname.startsWith('/asetqu-land') || pathname === '/my-asetqu-land')) {
      return {
        title: 'My AsetQu Land',
        subtitle: 'Get exclusive and attractive vouchers for you !',
        link: '/my-asetqu-land',
      };
    }

    return null;
  };

  const infoBanner = getInfoBannerData();

  return (
    <div className='w-full bg-white border-b border-gray-200 px-8 py-3'>
      <div className='max-w-[1920px] mx-auto flex items-center justify-between gap-4'>
        {/* Left: Download App */}
        <div className='flex items-center gap-2 text-sm text-gray-700 min-w-fit'>
          <Smartphone size={16} className='text-gray-600' />
          <span className='font-medium'>Download AsetQu HUB App</span>
        </div>

        {/* Right: Info Banner + Search Bar */}
        <div className='flex items-center gap-3'>
          {/* Info Banner (conditionally shown) */}
          {infoBanner && (
            <button
              onClick={() => navigate(infoBanner.link)}
              className='flex items-center gap-3 bg-gradient-to-r from-teal-700 to-blue-700 rounded-lg px-6 py-2.5 shadow-md hover:shadow-lg transition-shadow group'
            >
              <div className='w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center'>
                <History size={20} className='text-white' />
                {/* <img src='/icon-history.png' alt='History' className='w-10 h-10' /> */}
              </div>
              <div className='text-left'>
                <p className='text-sm font-bold text-white leading-tight'>{infoBanner.title}</p>
                <p className='text-xs text-white/90 leading-tight'>{infoBanner.subtitle}</p>
              </div>
              <ArrowRight
                size={20}
                className='text-white group-hover:translate-x-1 transition-transform'
              />
            </button>
          )}

          {/* Token Info */}
          <a
            href='https://www.asetqu.com'
            target='_blank'
            rel='noopener noreferrer'
            className='flex items-center gap-3 bg-gradient-to-r from-emerald-50 to-teal-50 border border-emerald-200 hover:border-emerald-400 hover:from-emerald-100 hover:to-teal-100 px-4 py-2 rounded-full transition-all group'
          >
            <div className='w-7 h-7 rounded-full overflow-hidden flex-shrink-0 ring-2 ring-emerald-200 group-hover:ring-emerald-400 transition-all'>
              <img src='/asetqu.png' alt='AsetQu Token' className='w-full h-full object-cover' />
            </div>
            <div className='flex flex-col leading-tight'>
              <span className='text-xs text-gray-400 font-medium'>Main Token</span>
              <span className='text-sm font-bold text-emerald-700'>AsetQu</span>
            </div>
            <ExternalLink
              size={13}
              className='text-gray-400 group-hover:text-emerald-500 transition-colors ml-1'
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default TopInfoBar;
